// @wc-ignore-file
// (Modes and role names are data, not copy.)

import type { ContainerRole } from "@shared/types/supabase.types";

/**
 * CR-183: how the caller reaches a `$projectSlug` route. `contributor` is a
 * user whose own row on the project is `contributor` (or who only holds the
 * workspace contributor anchor): their single page is `suggestions`.
 */
export type ProjectAccess = "member" | "contributor";

/** The project access mode for the caller's own membership role on the project. */
export function projectAccessFromRole(role: ContainerRole | null | undefined): ProjectAccess {
  return role === "contributor" ? "contributor" : "member";
}
